<div class="company-call-history-table__table">
  <table>
    <thead>
      <tr>
        <th class="company-call-history-table__cell company-call-history-table__cell-header">
          {{ "events.company-call-history.table.headers.phone-number" | Translate }}
        </th>
        <th class="company-call-history-table__cell company-call-history-table__cell-header">
          {{ "events.company-call-history.table.headers.from" | Translate }}
        </th>
        <th class="company-call-history-table__cell company-call-history-table__cell-header">
          {{ "events.company-call-history.table.headers.to" | Translate }}
        </th>
        <th class="company-call-history-table__cell company-call-history-table__cell-header">
          {{ "events.company-call-history.table.headers.actions" | Translate }}
        </th>
      </tr>
    </thead>
    <tbody *ngIf="!loading && callLog.length > 0">
      <tr
        *ngFor="let call of callLog"
        class="company-call-history-table__row">
        <td
          *ngIf="call.number; else empty"
          class="company-call-history-table__cell company-call-history-table__cell-item">
          {{ call.number }}
        </td>
        <td
          *ngIf="call.from; else empty"
          class="company-call-history-table__cell company-call-history-table__cell-item">
          <ng-container
            [ngTemplateOutlet]="tel"
            [ngTemplateOutletContext]="{
              link: call.callLinks.from,
              name: call.from,
              fullname: call.fromFull
            }"></ng-container>
        </td>
        <td
          *ngIf="call.to; else empty"
          class="company-call-history-table__cell company-call-history-table__cell-item">
          <ng-container
            [ngTemplateOutlet]="tel"
            [ngTemplateOutletContext]="{
              link: call.callLinks.to,
              name: call.to,
              fullname: call.toFull
            }"></ng-container>
        </td>
        <td class="company-call-history-table__cell company-call-history-table__cell-item">
          <i
            [ngClass]="call.recorded || call.voicemail ? 'icon-small-play-outline' : 'icon-small-info-outline'"
            (click)="openDetails(call)"></i>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="!loading && callLog.length === 0">
      <tr class="company-call-history-table__row">
        <td
          colspan="100"
          class="company-call-history-table__cell company-call-history-table__cell-item company-call-history-table__cell-no-res">
          {{ "events.company-call-history.table.no-records" | Translate }}
        </td>
      </tr>
    </tbody>

    <tbody *ngIf="loading">
      <tr
        class="company-call-history-table__row"
        *ngFor="let row of skeletonRows">
        <td
          colspan="100"
          class="company-call-history-table__cell company-call-history-table__cell-item">
          <ngx-skeleton-loader
            style="display: flex"
            [theme]="{ 'height.px': 20, 'width.%': 100, 'margin-bottom.px': 0 }"></ngx-skeleton-loader>
        </td>
      </tr>
    </tbody>
  </table>

  <ng-template
    #tel
    let-link="link"
    let-name="name"
    let-fullname="fullname">
    <span>
      {{ name }}
    </span>
  </ng-template>

  <ng-template #empty>
    <td class="company-call-history-table__cell company-call-history-table__cell-item">-</td>
  </ng-template>
</div>
